/**
 * Variáveis
 * data-tab-menu-item - Itens responsáveis por exibir o conteúdo correto no menu a esquerda ao clicar neles.
 * data-menu-secundario - Elemento responsável por ser o wrapper do conteúdo
 * data-close-menu - Fecha o menu quando estiver aberto
 */

// Get o menu
function getMenuPrincipal() {
	return $("#menuPrincipalEsquerdo");
}

// Get menu secundario
function getMenuSecundario(menu) {
	return menu.find("[data-menu-secundario]");
}

// Retira o is-active do item que está ativo
function removeActiveMenuItem(menu) {
    menu.find("[data-tab-menu-item]").each(function() {
        $(this).removeClass("is-active");
    });
	menu.find(".menu-left-secondary-wrapper-item.is-active").removeClass("is-active");
}

// Adiciona click para fechar o menu se tiver overlay
function closeMenu(menu, secundario) {
    menu.on("click", function (event) {

        var elementClicked = $(event.target);
        if(elementClicked.hasClass("overlay")) {
            menu.removeClass("overlay");
            secundario.removeClass("is-active");
            removeActiveMenuItem(menu);
        }
    })
    menu.find("[data-close-menu]").on("click", function () {
            menu.removeClass("overlay");
            secundario.removeClass("is-active");
            removeActiveMenuItem(menu);
    })
}

// Adiciona o is-acitve no item correspondente ao data atributo do item clicado
function addActiveMenuItem(menu, dataValue) {
	menu.find(dataValue).addClass("is-active");
}

// Active closest li of click
function closestLi(menu, dataValue) {
    menu.find(".menu-left-primary").find("li[data-tab-menu-item='"+dataValue+"']").addClass("is-active");
}

// Adiciona evento de click e a função que executa
function addClick(menu,secundario) {
	menu.find("[data-tab-menu-item]").each(function() {
        var dataValue = $(this).data("tab-menu-item");
		$(this).click(function(event) {
            removeActiveMenuItem(menu);
            closestLi(menu, dataValue);
            addActiveMenuItem(menu, dataValue);
            openMenuAbsolute(menu, secundario);  
		});
	});
}

// Checa se é absolute ou não
function openMenuAbsolute(menu, secundario) {
    if(!secundario.hasClass("is-active")) {
        secundario.addClass("is-active");
        menu.addClass("overlay");
    }
}
// Inicializa a aplicação
function init() {
    var menu = getMenuPrincipal();
    var secundario = getMenuSecundario(menu);
    closeMenu(menu, secundario);
	addClick(menu,secundario);
}

module.exports = {
	init
};



// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/menuPrincipal.js